import { call, put, takeLatest } from "redux-saga/effects";

// Login Redux States
import {
  ADD_API_CONFIGURATION,
  GET_API_CONFIGURATION,
  EDIT_API_CONFIGURATION,
} from "./actionTypes";

import {
  addApiConfiguration,
  getApiConfiguration,
  editApiConfiguration,
} from "../../../http/UAM/apiConfig.helper";
import { allApiConfiguration } from "./action";
import { decryptedValue } from "common/utility";

function* addApiConfigurations({ payload: { data, history } }) {
  try {
    const responseFromAPI = yield call(addApiConfiguration, data);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/api-config`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* getApiConfigurations({ payload: { data } }) {
  try {
    const responseFromAPI = yield call(getApiConfiguration, data);
    if (responseFromAPI.code == 200) {
      const { data } = responseFromAPI;
      yield put(allApiConfiguration({ data }));
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* editApiConfigurations({ payload: { data, history } }) {
  try {
    const responseFromAPI = yield call(editApiConfiguration, data);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/api-config`);
    }
  } catch (error) {
    console.log("error", error);
  }
}

function* ApiConfigurationSaga() {
  yield takeLatest(ADD_API_CONFIGURATION, addApiConfigurations);
  yield takeLatest(GET_API_CONFIGURATION, getApiConfigurations);
  yield takeLatest(EDIT_API_CONFIGURATION, editApiConfigurations);
}

export default ApiConfigurationSaga;
